import { createRoute, redirect } from '@tanstack/react-router'

import { sendInsidersOn } from '../auth/entrance.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { entryRoute } from './entry.tsx'
import { validateSignInSearch } from './sign-in.tsx'

// The door to the application: the entrance with no sheet, for a visitor; a redirect for
// everyone else. The login is `/sign-in`, over this same frame.
export const homeRoute = createRoute({
  getParentRoute: () => entryRoute,
  path: NAV_PATHS.home,
  // The login's own search, parsed as there: an old link to the door carries `reason` and
  // `returnTo` on to it.
  validateSearch: validateSignInSearch,
  staticData: { entryDoor: true },
  beforeLoad: async ({ context, search }) => {
    if (search.reason !== undefined || search.returnTo !== undefined) {
      throw redirect({ to: NAV_PATHS.signIn, search })
    }
    await sendInsidersOn(context.queryClient)
  },
})
